import React, { useState, useEffect } from "react"
import moment from "moment"
import { useCalendarGenerator } from "../lib/utils"
import styles from "./Calendar.module.css"

const today = moment()
const currentYear = today.year()
const currentMonth = today.month()

const Calendar = ({ departure, arrival, defaultValue, onDateSelect, onClose, passengerCount, showCalendar }) => {
    const [year, setYear] = useState(currentYear)
    const [month, setMonth] = useState(currentMonth)
    const [selectedDate, setSelectedDate] = useState(defaultValue)
    const [tooltip, setTooltip] = useState({ visible: false, content: "" })
    const generateCalendar = useCalendarGenerator()

    useEffect(() => {
        if (defaultValue) {
            setSelectedDate(defaultValue)
        }
    }, [defaultValue])


    const handleDateClick = (date, availableTickets, isPast) => {
        if (availableTickets > 0 && !isPast && availableTickets >= passengerCount) {
            setSelectedDate(date)
            onDateSelect(date)
        }
    }

    const handleMouseOver = (event, content) => {
        setTooltip({ visible: true, content })
    }

    const handleMouseOut = () => {
        setTooltip({ visible: false, content: "" })
    }

    const renderMonth = (monthOffset) => {
        const targetMonth = moment([year, month]).add(monthOffset, "months")
        const calendarDays = generateCalendar(
            departure,
            arrival,
            targetMonth.year(),
            targetMonth.month(),
        )

        return (
            <div className={styles.month}>
                <div className={styles.header}>
                    <span>{targetMonth.format("MMMM YYYY")}</span>
                </div>
                <div className={styles.grid}>
                    {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                        <div key={day} className={styles.dayLabel}>
                            {day}
                        </div>
                    ))}
                    {calendarDays.map((day, index) => (
                        <div
                            key={index}
                            className={`${styles.day} ${!day.date
                                ? styles.empty
                                : day.date === today.format("YYYY-MM-DD") ? styles.today :
                                    day.isPast
                                        ? styles.past
                                        : day.availableTickets === 0
                                            ? styles.unavailable
                                            : day.availableTickets < passengerCount ?
                                                styles.seatsOutOfRange
                                                : day.date === selectedDate
                                                    ? styles.selected
                                                    : styles.available
                                }`}
                            onClick={() =>
                                day.date &&
                                handleDateClick(day.date, day.availableTickets, day.isPast)
                            }
                            onMouseOver={(e) =>
                                day.date &&
                                handleMouseOver(
                                    e,
                                    day.availableTickets > 0
                                        ? `${day.availableTickets} tickets | ${day.ticketPrice}${day.currency}`
                                        : "No tickets available"
                                )
                            }
                            onMouseOut={handleMouseOut}
                            data-bs-toggle="tooltip"
                            title={tooltip.content}
                            tabIndex={1}
                        >
                            {day.date ? moment(day.date).date() : ""}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    const nextMonth = () => {
        const next = moment([year, month]).add(1, "months")
        setYear(next.year())
        setMonth(next.month())
    }

    const previousMonth = () => {
        const previous = moment([year, month]).subtract(1, "months")
        setYear(previous.year())
        setMonth(previous.month())
    }

    const handleModalClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose()
        }
    }

    return (
        <div className={`modal fade d-block ${showCalendar ? "show" : "hide"}`} tabIndex="-1" role="dialog" onClick={handleModalClick}>
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className={styles.navigation}>
                            <button type="button" className={styles.chevronIcon} onClick={previousMonth}>
                                <span className="material-symbols-outlined">chevron_left</span>
                            </button>
                            <button type="button" className={styles.chevronIcon} onClick={nextMonth}>
                                <span className="material-symbols-outlined">chevron_right</span>
                            </button>
                        </div>
                        <div className={styles.monthsContainer}>
                            {renderMonth(0)}
                            {renderMonth(1)}
                        </div>
                        <div className="modal-footer mt-5">
                            <button type="button" className="btn btn-primary" onClick={onClose}>
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Calendar